import { render, staticRenderFns } from "./list-head.vue?vue&type=template&id=193efae0&scoped=true&"
import script from "./list-head.vue?vue&type=script&lang=js&"
export * from "./list-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193efae0",
  null
  
)

export default component.exports